import { HTMLProps, useState } from "react";
import { Skeleton } from "@mui/material";
import { getAlphabetImageSrc } from "../alphabet-images";

export function CoreProfileImage({
	src,
	name,
	isLoading: externalLoading,
	size = 32,
	style,
	...imgProps
}: {
	name?: string;
	isLoading?: boolean;
	size?: number | string;
} & Omit<HTMLProps<HTMLImageElement>, "width" | "height" | "onLoad" | "onError">) {
	const [imageLoading, setImageLoading] = useState(true);
	const [isError, setIsError] = useState(false);

	const isLoading = externalLoading || (src && imageLoading);
	const isLoaded = src && !isLoading && !isError;

	const sharedStyles = {
		width: size,
		height: size,
		borderRadius: "50%",
	};

	return (
		<>
			{isLoading && <Skeleton variant="circular" width={size} height={size} />}
			<img
				{...imgProps}
				src={src}
				onLoad={() => setImageLoading(false)}
				onError={() => {
					setImageLoading(false);
					setIsError(true);
				}}
				style={{
					...style,
					...sharedStyles,
					display: isLoaded ? undefined : "none",
				}}
			/>
			{!isLoading && !isLoaded && (
				<img {...imgProps} src={getAlphabetImageSrc(name)} style={{ ...style, ...sharedStyles }} />
			)}
		</>
	);
}
